import VueMoment from 'vue-moment'
import vueNumeralFilterInstaller from 'vue-numeral-filter';
import store from '@/store'

const GlobalFilters = {
 
    install (Vue) {

        Vue.use(vueNumeralFilterInstaller)
        Vue.use(VueMoment)
    

        Vue.filter('modusignStatus', function (value) {
            if (!value) return value
            switch (value) {
                case 'ON_GOING' : return '서명 진행 중';  
                case 'ON_PROCESSING' : return '문서 처리 중';  
                case 'PROCESSING_FAILED' : return '문서 처리 실패';  
                case 'ABORTED' : return '서명 중단됨';  
                case 'COMPLETED' : return '모든 서명 완료';  
            }

            return value

        })

        Vue.filter('modusignAbortStatus', function(value) {
            if (!value) return value
            switch (value) {
                case 'REJECTION' : return '거절됨';  
                case 'SIGNING_CANCELLATION' : return '서명 후 취소';  
                case 'REQUEST_CANCELLATION' : return '요청 취소';  
            }
            return value
        })

        Vue.filter('statusColor', function (value) {
            if (!value) return value
            switch (value) {
                case 'ON_GOING' : return 'text-info';  
                case 'ON_PROCESSING' : return 'text-success';  
                case 'PROCESSING_FAILED' : return 'text-danger';  
                case 'ABORTED' : return 'text-warning';  
                case 'COMPLETED' : return 'text-primary2';  
            }

            return value

        })

   
        Vue.filter('roleNm', function (value) {
            if (!value) return value
            return store.state.common.roleOptions.find(item=>item.value === value).text
        })
        
        Vue.filter('fileSize', function(size) {
            if (size === 0) return '0 Bytes';
            const k = 1024;
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
            const i = Math.floor(Math.log(size) / Math.log(k));
            const decimal = 2;
            return parseFloat((size / Math.pow(k, i)).toFixed(decimal)) + ' ' + sizes[i];
        })
        
    }    
    
}

export default GlobalFilters
